import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from "@angular/core";
import { DxTagBoxTypes } from "devextreme-angular/ui/tag-box";
import DataSource from "devextreme/data/data_source";
import type { CollectionWidgetItem } from "devextreme/ui/collection/ui.collection_widget.base";
import type {
  CustomItemCreatingEvent,
  ValueChangedEvent
} from "devextreme/ui/tag_box";
import { arrayContainsSameItems } from "src/app/support/array";

@Component({
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "snt-tag-box",
  templateUrl: "tag-box.component.html"
})
export class TagBoxComponent {
  value = input.required<Array<any | number | string>>();

  valueExpr = input.required<
    ((item: any) => string | number | boolean) | string
  >();

  displayExpr = input.required<((item: any) => string) | string | undefined>();

  dataSource = input.required<
    Array<any | CollectionWidgetItem> | DataSource | null | undefined
  >();

  searchEnabled = input.required<boolean>();

  tagTemplate = input.required<any>();

  acceptCustomValue = input.required<boolean>();

  placeholder = input<string | undefined>();

  customItemCreateEvent = input.required<string>();

  readonly onValueChanged = output<ValueChangedEvent>();

  readonly onCustomItemCreating = output<CustomItemCreatingEvent>();

  onValueChangedInternal(dxEvent: DxTagBoxTypes.ValueChangedEvent): void {
    if (
      arrayContainsSameItems(dxEvent.previousValue || [], dxEvent.value || [])
    ) {
      return;
    }

    this.onValueChanged.emit(dxEvent);
  }
}
